import {
    TableViewStore,
    BaseListViewStore
} from 'core/stores';
import applicationContext from 'core/utils/applicationContext';
import { ImportDetailService } from 'application/import/services';
import { action, observable, runInAction } from 'mobx';
import { ReferenceChangeCell,ConfirmationCell } from 'application/import/components';
import _ from 'lodash';

@applicationContext
class ImportPatientViewStore extends BaseListViewStore {
    @observable accessor isProcessing = false;  
    @observable accessor needsConfirmation = false;
    constructor(rootStore) {
        const importId = rootStore.routerStore.routerState.params.id;
        const service = new ImportDetailService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'import patient',
            autoInit: true,
            authorization: {
                delete: 'portalSection.delete'
            },
            routes: {
                edit: (item) => {
                    let newPatient = item.patientDetailId && !item.patientId;
                    let route = newPatient ? 'master.app.main.patient-detail.edit': 'master.app.main.import.detail.edit' ;
                    if(!newPatient)
                    {
                        this.rootStore.routerStore.setTransitionData({
                            navigationTitle: item.firstName + ' ' + item.lastName
                        });

                        this.rootStore.routerStore.goTo(route,{ id: importId, importPatientId: item.patientGroupId});                        
                    }
                    else
                    {
                        this.rootStore.routerStore.goTo(route,{ id: item.patientDetailId});
                    }
                },
                preview: (item) =>{
                    this.rootStore.routerStore.goTo(
                        'master.app.main.patient-detail.preview',
                        { id: item.patientDetailId }
                    );
                },
                duplicates: (item) => {
                    this.rootStore.routerStore.goTo(
                        'master.app.main.import.detail.duplicate.list',
                        { id: item.patientDetailId, firstName: item.firstName, lastName: item.lastName, importHeaderId: importId, patientGroupId: item.patientGroupId}
                    );
                }
            },
            actions: () => {
                return {
                    find: async (params) => {
                        const response = await service.findGroupedByPatients(
                            _.extend(
                                params,
                                { 
                                    importHeaderId : importId
                                }
                            )
                        );
                        
                        runInAction(() => {
                            this.needsConfirmation = false;
                            response.item.forEach(x=> {
                                if(x.importValidations.find(x=>x.validation.needsConfirmation && !x.isDone)){
                                    this.needsConfirmation = true;
                                }
                            });
                        });
                        
                        const res =  _.extend(response,
                            {
                                item: _.map(response.item, (item => {
                                    return _.extend(
                                        item, {
                                            status: item.importDetailStatus.name,
                                            noOfDuplicates: !item.patientBtId ? item.noOfDuplicates : '',  
                                            importHeaderId: importId,
                                            fetch: ()=> this.queryUtility.fetch(),
                                            facilityId: this.facilityId                                     
                                        }
                                        );
                                    }))                         
                            });
                        return res;
                    },
                    delete: async (item) => {
                        await service.remove(item);
                    }
                }
            }
        });

        this.service = service;
        this.importHeaderId = importId;
        this.patientIds = [];
        this.getIsProcessing();

        this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: [
                {
                    key: 'lastName',
                    title: 'IMPORT_PATIENT.LIST.COLUMNS.LAST_NAME',
                    onClick: (item) => this.routes.edit(item)
                },
                {
                    key: 'firstName',
                    title: 'IMPORT_PATIENT.LIST.COLUMNS.FIRST_NAME',
                    onClick: (item) => this.routes.edit(item)
                },
                {
                    key: 'noOfDuplicates',
                    title: 'IMPORT_PATIENT.LIST.COLUMNS.NO_OF_DUPLICATES',
                    
                    onClick: (item) => {
                        if(item.patientBtId) {  
                            this.routes.edit(item);
                        }
                        else {
                            this.routes.duplicates(item);
                        }
                    }
                },
                {
                    key: 'referenceChange',
                    title: 'IMPORT_PATIENT.LIST.COLUMNS.REFERENCE_CHANGE',
                    onClick: (item) => this.routes.edit(item),
                    cell: ReferenceChangeCell
                },
                {
                    key: 'confirmation',
                    title: 'Validations',
                    cell: ConfirmationCell
                },
                {
                    key: 'status',
                    title: 'IMPORT_PATIENT.LIST.COLUMNS.STATUS',
                    onClick: (item) => this.routes.edit(item)
                }
            ],
            actions: {
                onPatient: (item) => item.patientBtId != null ? 
                    window.open(`https://brightree.net/F1/0183/InnovativeSup/Patient/frmPatientSummary.aspx?PatientKey=${item.patientBtId}&Edit=0&ShowAck=1`)
                    : null,
                onPreview: (item) => this.routes.preview(item),
                onDelete: (item) => this.deleteResource(item),
                onEdit: (item) => this.routes.edit(item)
            }
        }));
    }

    @action.bound
    async getIsProcessing() {
        let response = await this.service.isRunning({importHeaderId: this.importHeaderId});
        runInAction(() => {
            this.isProcessing = response;
        });
    }

    @action.bound
    async importAll() {
        this.loaderStore.suspend();
        try {
            await this.service.importAll({ importHeaderId: this.importHeaderId });

            this.rootStore.routerStore.goBack();
            this.rootStore.notificationStore.success("Import successfully done.");                       
        }
        catch(err) {
            this.rootStore.notificationStore.error("Error occured on import.");
        }   
        this.loaderStore.resume();        
    }

}

export default ImportPatientViewStore;
